// Import necessary tools
import { Navigate, useLocation } from "react-router-dom";
import { getTokenFromCookie, getDecodedToken } from "../utils/tokenHelper";
import UnauthorizedPage from "../pages/common/UnauthorizedPage";

// Define what props this component can receive
interface ProtectedRouteProps {
  children: React.ReactNode;  // This is the content we want to protect
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // Get the current URL and check if there's a token in the URL
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryToken = searchParams.get('jtToken');  // Get token from URL if it exists

  // Get token from cookie and decode it
  const cookieToken = getTokenFromCookie();  // Get token from browser cookie
  const decodedToken = getDecodedToken();    // Decode the token to read its contents


  // CHECK 1: Is there a valid token in the cookie?
  if (cookieToken && decodedToken) {
    const currentTime = Math.floor(Date.now() / 1000);
    if (decodedToken.exp < currentTime) {
    //   console.log("Cookie token is expired");
      return <UnauthorizedPage />;
    }
    // console.log("Valid cookie token found");
    return <>{children}</>;  // Allow access if token is valid
  }

  // CHECK 2: Is there a token in the URL?
  if (queryToken) {
    try {
      // Try to read and validate the token from URL
      const payload = queryToken.split('.')[1];
      const decodedQueryToken = JSON.parse(atob(payload));
      
      // Check if token has all required information and isn't expired
      const currentTime = Math.floor(Date.now() / 1000);
      if (!decodedQueryToken.userId || !decodedQueryToken.companyId || decodedQueryToken.exp < currentTime) {
        // console.log("Invalid query token");
        return <UnauthorizedPage />;
      }

      // If token is valid, save it to cookie for future use
      document.cookie = `jtToken=${queryToken}; path=/`;
    //   console.log("Valid query token, setting cookie");
      return <>{children}</>;  // Allow access
    } catch (error) {
    //   console.log("Error decoding query token");
      return <UnauthorizedPage />;
    }
  }

  // If we get here, there's no valid token anywhere
  console.log("No valid token found");
  return <UnauthorizedPage />;
}

export default ProtectedRoute;